import {getToken} from "@/helpers/auth/auth-helper";

/**
 *
 * @param url
 * @param type
 * @param data
 * @param contentType
 * @param isfetch
 * @param withToken
 * @returns {Promise<{getAllResponseHeaders: function(): *|null, abort: function(*=): this, setRequestHeader: function(*=, *): this, readyState: number, getResponseHeader: function(*): null|*, overrideMimeType: function(*): this, statusCode: function(*=): this}|*|jQuery>}
 */
export async function performHttpRequest(url,
                                         type = 'GET',
                                         data = null,
                                         contentType= 'application/json',
                                         isfetch = true,
                                         withToken = true)     {

    if(type === 'POST' && isfetch) {
        var myHeaders = new Headers();

        if(contentType) {
            myHeaders.append("Content-Type", contentType);
        }

        let token = getToken()
        if(withToken && token !== undefined) {
            myHeaders.append("Authorization", token);
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(data)
        };

        return fetch(url, requestOptions)
    }


    return new Promise(function (resolve, reject) {
        const Http = new XMLHttpRequest();
        Http.open(type, url);
        Http.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        Http.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0");

        let token = getToken()
        if(withToken && token !== undefined) {
            Http.setRequestHeader("Authorization", token);
        }

        Http.onload = function () {
            if (Http.status >= 200 && Http.status < 300) {

                if(Http.response === "") {
                    reject({
                        status: Http.status,
                        statusText: Http.statusText
                    });
                } else {
                    if(contentType === 'application/json') {
                        resolve(JSON.parse(Http.response));
                    } else {
                        resolve(Http.response);
                    }
                }

            } else {
                reject({
                    status: Http.status,
                    statusText: Http.statusText
                });
            }
        };
        Http.onerror = function () {
            reject({
                status: Http.status,
                statusText: Http.statusText
            });
        };
        Http.send(serialize(data));
    })
}

export function serialize(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}
